export default __webpack_public_path__ + "static/media/z2.9bee5df0.jpeg";